import React, { useState } from "react";
import { FaTimes, FaMale, FaFemale } from "react-icons/fa";
import DressCode from "./DressCode";
import "./DressCodePopup.css";

const DressCodePopup = () => {
  const [showDressCode, setShowDressCode] = useState(false);

  return (
    <>
      {/* SERVICE BUTTON */}
      <button
        className="dress-service-btn dress-service-btn-1 "
        onClick={() => setShowDressCode(true)}
      >
        <span className="dress-service-icon">
          <FaMale />
          <FaFemale />
        </span>

        <span className="dress-service-text">
          <small>TEMPLE GUIDELINES</small>
          Dress Code for Darshan
        </span>
      </button>


      {/* POPUP */}
      {showDressCode && (
        <div className="dress-popup-overlay">

          <div className="dress-popup">

            {/* CLOSE BUTTON */}
            <button
              className="dress-popup-close"
              onClick={() => setShowDressCode(false)}
              aria-label="Close Dress Code"
            >
              <FaTimes />
            </button>

            {/* YOUR EXACT DRESS CODE DESIGN */}
            <DressCode />

          </div>

        </div>
      )}
    </>
  );
};

export default DressCodePopup;